'use client';

import { cn } from '@/lib/utils';

/**
 * Small pill toggle used to filter a page list (All / Problems) with a count
 * badge. Shared by the page-thumbnail rail (and formerly the QR grid) so both
 * surfaces render the same chip.
 */
export function FilterChip({
  active,
  count,
  label,
  tone,
  onClick
}: {
  active: boolean;
  count: number;
  label: string;
  tone: 'slate' | 'amber';
  onClick: () => void;
}) {
  return (
    <button
      type='button'
      onClick={onClick}
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold transition-colors',
        active
          ? tone === 'amber'
            ? 'border-amber-300 bg-amber-100 text-amber-800 dark:border-amber-700 dark:bg-amber-950/50 dark:text-amber-200'
            : 'border-slate-300 bg-slate-200 text-slate-800 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-100'
          : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800'
      )}
    >
      <span>{label}</span>
      <span
        className={cn(
          'inline-flex min-w-[18px] items-center justify-center rounded-full px-1 font-mono text-[10px]',
          active
            ? tone === 'amber'
              ? 'bg-amber-200 text-amber-900 dark:bg-amber-900 dark:text-amber-100'
              : 'bg-slate-300 text-slate-700 dark:bg-slate-600 dark:text-slate-100'
            : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300'
        )}
      >
        {count}
      </span>
    </button>
  );
}
